import React, { useEffect, useRef, useState } from 'react';
import { OneWorldSyncEnergyLabelProps, OneWorldSyncLoaderInfoProps } from 'types/OneWorldSyncLoaderTypes';
import loadOneWorldSync from 'utilities/oneWorldSync/oneWorldSync-util';
import { useFeatureTogglesContext } from 'context/FeatureToggle/FeatureToggleContext';
import styles from './EnergyLabel.module.css';

function EnergyLabel(props: OneWorldSyncEnergyLabelProps) {
  const { brand, mpn, ean, option, site } = props;
  const featureToggles = useFeatureTogglesContext();
  const energyLabelRedesignEnabled = !!featureToggles?.enableEnergyLabelRedesign;
  const [energyIcon, setEnergyIcon] = useState<{ src: string; alt: string } | null>(null);
  const originalImgRef = useRef<HTMLImageElement | null>(null);

  useEffect(() => {
    if (brand) {
      const loaderInfo: OneWorldSyncLoaderInfoProps = {
        brand,
        window,
        option,
        mpn,
        ean,
        site,
      };
      loadOneWorldSync(loaderInfo);
    }
  }, [brand]);

  useEffect(() => {
    if (!energyLabelRedesignEnabled) return undefined;

    let timeout: ReturnType<typeof setTimeout>;

    const observer = new MutationObserver(() => {
      const img = document.querySelector<HTMLImageElement>('#ccs-logos img[role="button"]');
      if (!img) return;

      clearTimeout(timeout);
      observer.disconnect();
      originalImgRef.current = img;
      setEnergyIcon({ src: img.src, alt: img.alt });
    });

    timeout = setTimeout(() => observer.disconnect(), 5000);

    observer.observe(document.body, { childList: true, subtree: true });

    return () => {
      clearTimeout(timeout);
      observer.disconnect();
    };
  }, [energyLabelRedesignEnabled]);

  return (
    <>
      <div id="cnet-energyInfo" data-testid="oneworldsync-energy-label" className={styles.wrapper}>
        <div id="ccs-logos" style={energyIcon ? { display: 'none' } : undefined} />
        <div id="ccs-product-fiche" />
      </div>
      {energyLabelRedesignEnabled && energyIcon && (
        <button
          type="button"
          aria-label={energyIcon.alt || 'Energy rating'}
          className={styles.energyButton}
          onClick={() => originalImgRef.current?.click()}
        >
          <img src={energyIcon.src} alt={energyIcon.alt} />
          <span>Product information sheet</span>
        </button>
      )}
    </>
  );
}

export default EnergyLabel;
